import { useQuery } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'
import type { Id } from '@ppwr/convex/_generated/dataModel'

/**
 * Subscribe to the calling user's current tournament-table snapshot.
 *
 * Returns `undefined` while loading and `null` when the user has no
 * participating row (never registered, fully eliminated, etc).
 *
 * Centralizes the `getMyTournamentTable` subscription so every consumer
 * pulls from the same Convex dedupe. Pass `undefined` for tournamentId
 * to disable the subscription (e.g. on non-tournament screens).
 */
export function useMyTournamentTable(tournamentId: Id<'tournaments'> | undefined) {
  return useQuery(
    api.tournaments.queries.getMyTournamentTable,
    tournamentId ? { tournamentId } : 'skip'
  )
}
